module.exports = __webpack_public_path__ + "img/waterMarkNew.96febaab.png";